module.exports = __webpack_public_path__ + "static/media/004-dentist.692e1bdb.svg";